import { PDFParse } from "pdf-parse";
import workerModuleUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let configured = false;

/** Configure pdf.js worker once for browser PDF text extraction. */
export function ensurePdfWorkerConfigured(): void {
  if (configured || typeof window === "undefined") return;

  const workerSrc = workerModuleUrl.startsWith("http")
    ? workerModuleUrl
    : new URL(workerModuleUrl, window.location.origin).href;

  PDFParse.setWorker(workerSrc);
  configured = true;
}

ensurePdfWorkerConfigured();
